import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import { Switch } from '@st-operations/uikit/src/v2'
import pretty from '@st-operations/uikit/lib/pretty'

import Select from '_components/select'
import MultiValueInput from '_components/multi-value-input'

import { PERMISSIONS_SCHEMA } from './constants'

const Sector = ({ title, entities, permissions, handleChangePermissions }) => {
  return (
    <div className="internal-settings__permission">
      <h3>{title}</h3>
      <hr />
      <div className="internal-settings__permission-options">
        <For each="entity" of={entities}>
          <div key={entity} className="internal-settings__permission-entity">
            <Switch
              checked={!!permissions[entity]}
              onChange={() => handleChangePermissions(entity)}
            />
            {entity}
          </div>
        </For>
      </div>
    </div>
  )
}

const UserInternalSettings = ({
  type,
  editingUser,
  newUsers,
  orgOptions,
  setEditingUser,
  setNewUsers,
}) => {
  // clear user on unmount
  useEffect(() => {
    return () => setEditingUser(null)
  }, [])

  const setState = type === 'edit' ? setEditingUser : setNewUsers
  const { permissions } = type === 'edit' ? editingUser : newUsers

  const handleOrgChange = ({ value: org }) => setState((prev) => ({ ...prev, org }))
  const handleChangePermissions = (role) =>
    setState((prev) => ({
      ...prev,
      permissions: { ...prev.permissions, [role]: prev.permissions[role] ? null : 'admin' },
    }))
  const handleChangeEmails = (emails) => setNewUsers((prev) => ({ ...prev, emails }))

  return (
    <div className="internal-settings">
      <div className="internal-settings__meta">
        <MultiValueInput
          label={type === 'edit' ? 'Email address:' : 'Email addresses'}
          placeholder="john@example.com; mary@example.com"
          values={type === 'edit' ? [editingUser.email] : newUsers.emails}
          onChange={handleChangeEmails}
          required
          disabled={type === 'edit'}
          pasteRegex={/\r?\n| |,|;/g}
        />
        <Select
          label="Assign an org:"
          placeholder="Select..."
          value={
            type === 'edit'
              ? { value: editingUser.org, label: pretty(editingUser.org) }
              : { value: newUsers.org, label: pretty(newUsers.org) }
          }
          options={orgOptions}
          onChange={handleOrgChange}
          useReactSelect
          required
        />
      </div>
      <div className="internal-settings__permissions">
        <h2>Manage Permissions:</h2>
        <div className="internal-settings__permissions-block">
          <For each="permissionSet" of={PERMISSIONS_SCHEMA}>
            <Sector
              key={permissionSet.title}
              {...permissionSet}
              permissions={permissions}
              handleChangePermissions={handleChangePermissions}
            />
          </For>
        </div>
      </div>
    </div>
  )
}

UserInternalSettings.propTypes = {
  type: PropTypes.oneOf(['new', 'edit']),
  permissions: PropTypes.object,
  setEditingUser: PropTypes.func,
  setNewUsers: PropTypes.func,
}

UserInternalSettings.defaultProps = {
  type: 'new',
  permissions: {},
  setEditingUser: () => {},
  setNewUsers: () => {},
}

export default UserInternalSettings
